<!-- eslint-disable max-len -->
<template>
  <div class="home" v-show="!isMobileLogin">
    <HeaderLandingNew />
    <HeaderLandingNew :custom-class="'z-index-2'" />
    <HeaderLandingContent />
    <div class="container-section ">
      <div class="content-section-2">
        <b-container fluid class="mt-5 mb-5" style="min-height: 65vh;">
          <b-row align-h="center">
            <b-col cols="12" md="4">
              <b-form @submit="login" class="d-flex flex-column align-items-center">
                <b-nav pills class="mb-5 justify-content-center nav-signin">
                  <b-nav-item href="/#/register">Sign Up</b-nav-item>
                  <b-nav-item active>Log In</b-nav-item>
                </b-nav>
                <template v-if="showFormEmail">
                  <div class="w-100 d-flex justify-content-start align-items-center" style="margin-bottom: 32px">
                    <a @click="showFormEmail = false" class="cursor-pointer text-decoration-none" style="color: #4d4d4d">
                      <font-awesome-icon :icon="['fas', 'arrow-left']" class="icon-back" style="margin-right:20px"/>
                      <span style="font-size: 20px;line-height: 24px;">Back</span>
                    </a>
                  </div>
                  <h4 class="font-weight-bolder mb-4">Log In with Email</h4>
                  <b-form-group
                    id="input-group-1"
                    class="mb-4 w-100"
                  >
                    <b-form-input
                      id="input-1"
                      v-model="email"
                      type="email"
                      placeholder="Enter email"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group id="input-group-2" class="w-100">
                    <b-form-input
                      type="password"
                      id="input-2"
                      v-model="password"
                      placeholder="Enter Password"
                      required
                    ></b-form-input>
                    <div class="w-100"></div>
                    <p v-if="getStatus !== 200 && getErrorCode === 'ER-AUTH-02'" class="text-danger text-left">{{
                        getMessage
                      }}. </p>
                  </b-form-group>
                  <b-button type="submit" variant="primary" class="btn-block">Log In</b-button>
                  <a class="d-flex justify-content-end mt-2 text-dark" href="/#/forgot-password">Forgot Password?</a>
                </template>
                <template v-else>
                  <h4 class="font-weight-bolder mb-4">Log In to Your Account</h4>
                  <b-button type="button" variant="default" class="btn-block btn-social" @click="signInFB">
                    <img src="@/assets/fb-icon.svg" alt="logo"/>
                    Log In with Facebook
                  </b-button>
                  <b-button type="button" variant="default" class="btn-block btn-social" @click="signInGoogle">
                    <img src="@/assets/google-icon.svg" alt="logo"/>
                    Log In with Google
                  </b-button>
                  <b-button type="button" variant="default" class="btn-block btn-social" @click="signInApple">
                    <img src="@/assets/apple-icon.svg" alt="logo"/>
                    Log In with Apple
                  </b-button>
                  <b-button type="button" variant="default" class="btn-block btn-social" @click="showFormEmail = true">
                    <img src="@/assets/mail-icon.svg" alt="logo"/>
                    Log In with Email
                  </b-button>
                  <span class="d-flex justify-content-center"
                        style="margin-top: 56px;margin-bottom: 23px;font-size: 16px;line-height: 19px;">Don’t Have an Account?</span>
                  <b-button type="button" variant="primary" @click="goToRegister">
                    Sign Up
                  </b-button>
                </template>
                <div class="border-bottom border-dark mb-3" style="margin-top:89px"></div>
                <p class="text-center">Download MusicVerse. Your one-stop app for sacred music</p>
                <b-row class="justify-content-center align-items-center flex-column flex-sm-row">
                  <a :href="appStoreUrl" class="mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo" aria-label="App Store" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/applestore-logo.png" class="content-logo" alt="App Store">
                  </a>
                  <a :href="googlePlayUrl" class="mt-3 mt-sm-0 mr-0 mr-sm-3 content-logo" aria-label="Google Play" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/googleplay-logo.png" class="content-logo" alt="Google Play">
                  </a>
                  <a :href="appGalleryUrl" class="mt-3 mt-xl-0 content-logo radius" aria-label="App Gallery" target="_blank" rel="noopener noreferrer">
                    <img src="@/assets/huawei-logo.png" class="content-logo radius" alt="App Gallery">
                  </a>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <FooterLandingNew />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
// import clevertap from "clevertap-web-sdk";
import * as moment from 'moment';
import bgLanding from '@/assets/bg-landing.png';
import HeaderLanding from '../components/HeaderLanding';
import FooterLanding from '../components/FooterLanding';
import HeaderLandingNew from '@/components/HeaderLandingNew';
import FooterLandingNew from '@/components/FooterLandingNew';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  OAuthProvider,
  signOut,
  updateProfile
} from 'firebase/auth';
import HeaderLandingContent from '@/components/HeaderLandingContent.vue';

const MV_URL = process.env.MUSICVERSE_URL;
const MV_DONATION_ID = process.env.MUSICVERSE_DONATION_ID;
export default {
  name: 'Signin',
  data: () => ({
    isMobileLogin: false,
    isLoading: false,
    email: '',
    password: '',
    rememberMe: '0',
    isErrorVerification: '',
    mv_url: MV_URL,
    bgLanding,
    showFormEmail: false,
    appStoreUrl: process.env.VUE_APP_ALL_BUTTON_LINK_IOS || 'https://musicverse.onelink.me/vYmO/mainwebsite',
    googlePlayUrl: process.env.VUE_APP_ALL_BUTTON_LINK_ANDROID || 'https://musicverse.onelink.me/vYmO/mainwebsite',
    appGalleryUrl: 'https://appgallery.huawei.com/#/app/C104486453',
  }),
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode', 'getNextPage']),
    ...mapGetters('AuthModule', ['getUser']),
    labelSave() {
      return !this.isLoading ? 'Login' : '';
    },
  },
  watch: {
    getLoading: {
      immediate: true,
      handler(val) {
        this.isLoading = val;
      },
    },
    getMessage: {
      immediate: true,
      handler(val) {
        this.isErrorVerification = val.toLowerCase()
          .includes('please verify your email');
      },
    },
  },
  async mounted() {
    this.removeUserSocial();
    if (this.$route.query._t !== undefined && this.$route.query.type !== undefined) {
      const result = await this.removeAuthentication({ accessToken: this.accessToken });
      this.isMobileLogin = true;
      const response = await this.requestMobileAuth(this.$route.query._t);
      let url = 'Dashboard';
      if (this.$route.query.type == 'topup') {
        url = 'TopUpPage';
      } else if (this.$route.query.type == 'subscription') {
        url = 'SubscribePage';
      } else if (this.$route.query.type == 'survey') {
        url = 'SurveyPage';
      } else if (this.$route.query.type == 'change-subscription') {
        url = 'ChangeSubscriptionPage';
      } else if (this.$route.query.type == 'donation') {
        url = 'DonationsPage';
      }
      if (response) {
        setTimeout(() => {
          if (this.$route.query.type == 'donation') {
            this.$router.push({ name: url, query: { _d: MV_DONATION_ID } });
          } else {
            this.$router.push({ name: url });
          }
        }, 500);
      } else {
        this.isMobileLogin = false;
      }
    } else if (this.getUser !== '') {
      let url = 'Dashboard';
      if (this.$route.query.type !== undefined) {
        if (this.$route.query.type == 'topup') {
          url = 'TopUpPage';
        } else if (this.$route.query.type == 'subscription') {
          url = 'SubscribePage';
        } else if (this.$route.query.type == 'survey') {
          url = 'SurveyPage';
        } else if (this.$route.query.type == 'change-subscription') {
          url = 'ChangeSubscriptionPage';
        } else if (this.$route.query.type == 'update-payment') {
          url = 'UpdatePaymentPage';
        } else {
          this.$router.push({ name: url });
        }
      }
      this.$router.push({ name: url });
    }
  },
  methods: {
    ...mapActions('AuthModule', ['requestAuthentication', 'requestMobileAuth', 'removeAuthentication',
      'setUserSocial', 'removeUserSocial', 'requestAuthenticationSocial']),
    ...mapActions('NotificationModule', ['setNextPage']),
    redirectAfter() {
      if (this.getNextPage !== '') {
        const nextPageUrl = this.getNextPage;
        const [nextPage, paramsPage] = nextPageUrl.split('?');
        let params = {};
        if (paramsPage) {
          params = JSON.parse(`{"${paramsPage.replace(/&/g, '","')
            .replace(/=/g, '":"')}"}`, (key, value) => (key === '' ? value : decodeURIComponent(value)));
        }
        this.setNextPage('');
        this.$router.push({ name: nextPage, query: params });
      } else {
        if (this.$route.query.type !== undefined) {
          if (this.$route.query.type === 'update-payment') {
            document.location.href = '/#/update-payment';
          } else if (this.$route.query.type === 'subscription') {
            this.$router.push({ name: 'SubscribePage' });
          } else {
            this.$router.push({ name: 'Dashboard' });
          }
        } else {
          this.$router.push({ name: 'Dashboard' });
        }
      }
    },
    async login(event) {
      event.preventDefault();
      try {
        // eslint-disable-next-line max-len
        const user = { email: this.email, password: this.password };
        const response = await this.requestAuthentication(user);
        if (response) {
          this.removeUserSocial();
          this.redirectAfter();
        } else if (this.getStatus !== 200 && this.getErrorCode === 'ER-AUTH-01') {

        }
      } catch (err) {
        // console.log(err);
      }
    },
    async signInGoogle() {
      const provider = new GoogleAuthProvider();
      provider.addScope('email,profile');
      const auth = getAuth();
      await signOut(auth);
      signInWithPopup(auth, provider)
        .then(async (result) => {
          const user = result.user;
          this.setUserSocial({
            email: user.providerData[0].email,
            name: user.providerData[0].displayName,
            uid: user.providerData[0].uid,
            token: user.accessToken,
            method: 'google',
          });
          await this.loginSocial('google', {
            email: user.providerData[0].email,
            name: user.providerData[0].displayName,
            uid: user.providerData[0].uid,
            token: user.accessToken,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async signInFB() {
      const provider = new FacebookAuthProvider();
      provider.addScope('email,public_profile');
      const auth = getAuth();
      await signOut(auth);
      signInWithPopup(auth, provider)
        .then(async (result) => {
          const user = result.user;
          this.setUserSocial({
            email: user.providerData[0].email,
            name: user.providerData[0].displayName,
            uid: user.providerData[0].uid,
            token: user.accessToken,
            method: 'facebook',
          });
          await this.loginSocial('facebook', {
            email: user.providerData[0].email,
            name: user.providerData[0].displayName,
            uid: user.providerData[0].uid,
            token: user.accessToken,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async signInApple() {
      const provider = new OAuthProvider('apple.com');
      provider.addScope('email');
      provider.addScope('name');
      const auth = getAuth();
      await signOut(auth);
      signInWithPopup(auth, provider)
        .then(async (result) => {
          // eslint-disable-next-line max-len
          if (auth.currentUser.displayName === null && !!auth.currentUser.providerData[0].displayName) {
            await updateProfile(auth.currentUser, {
              displayName: auth.currentUser.providerData[0].displayName,
            });
          }
          const user = result.user;
          // console.log(user,'log user auth current user apple');
          // console.log(auth.currentUser,'log user auth current user firebase');
          this.setUserSocial({
            email: user.providerData[0].email,
            name: auth.currentUser.providerData[0].displayName ? auth.currentUser.providerData[0].displayName : '',
            uid: user.providerData[0].uid,
            token: user.accessToken,
            method: 'apple',
          });
          await this.loginSocial('apple', {
            email: user.providerData[0].email,
            name: auth.currentUser.providerData[0].displayName ? auth.currentUser.providerData[0].displayName : '',
            uid: user.providerData[0].uid,
            token: user.accessToken,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async loginSocial(method, data) {
      const response = await this.requestAuthenticationSocial({ ...data, method });
      if (response) {
        if (response.data) {
          this.removeUserSocial();
          this.redirectAfter();
        } else {
          this.goToRegister();
        }
      } else if (this.getStatus !== 200 && this.getErrorCode === 'ER-AUTH-01') {

      }
    },
    goToRegister() {
      this.$router.push({ name: 'Registration' });
    },
  },
  components: {
    HeaderLandingContent,
    HeaderLanding, FooterLanding,
    HeaderLandingNew, FooterLandingNew
  },
};
</script>
<style>
@import '../assets/stylesheets/landing.css';
.section-sign-in{
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.32) 0%, rgba(0, 0, 0, 0.32) 100%), url("~@/assets/bg-premium.jpg"), lightgray 0px -2.409px / 100% 112.294% no-repeat;
}
.section-sign-in .so-content p{
  width: 730px;
}
.btn-social {
  background: #FFFFFF;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
  border-radius: 999px;
  margin-bottom: 24px;
  padding: 20px 0;
  font-size: 20px;
  line-height: 24px;
  color: #4D4D4D;
}

.btn-social img {
  width: 40.96px;
  margin-right: 20.39px;
}
</style>



// WEBPACK FOOTER //
// src/views/Signin.vue